<style>
    .ngx-datatable .datatable-header {
        overflow: auto !important;
    }
</style>
<!--(window:resize)="onResize($event)"-->
<div #gridRow>
    <div class="row mb-2 pt-0">
        <div class="col-md-2 pt-0 d-flex align-items-center box-sort-left">
            <!-- [ngClass]="getCSSClasses()"-->
            <span class="pe-1">{{ "grid.show"|translate }}</span>
            <span class="ps-1 pe-1">
          <ng-select class="w-100 ng-select" [items]="itemsLimit" [(ngModel)]="searchQuery.limit"
                     (change)="sendRequest('resetPageOffset')" [clearable]="false" [searchable]="false"></ng-select>
        </span>
            <span class="ps-1">{{ "grid.rows"|translate }}</span>
            <span class="ms-2">
        <a href="javascript:" class=" action-button ripple light refresh-icon" (click)="refreshFilter()" placement="top"
           ngbTooltip="{{'global.refresh_filter' | translate}}">
        <i class="fa fa-repeat fa-lg" aria-hidden="true"></i></a>
      </span>
        </div>

        <div class="col-10 pt-0 box-sort-right" *ngIf="!grid.search||grid.multipleRowSearch ">
            <div class="row justify-content-end">
                <!--Normal search-->
                <ng-container *ngFor="let search of grid.search">
                    <ng-container *ngIf="search.hasNormalSearch">
                        <div class="col-md-3 pt-0 d-flex align-items-center"
                             [ngClass]="[search.order? 'order-'+search.order[0].normalSearchOrder:'' , search.hasDropdownListFilter && search.order ? 'offset-md-1':'']">
                            <label class="mb-0" for="gridSearch">{{ "grid.search"|translate }}&nbsp;</label>
                            <input #gridSearch type="text" class="form-control ms-2" id="gridSearch"
                                   [(ngModel)]="searchQuery.query"
                                   [placeholder]="grid.searchPlaceholder ? (grid.searchPlaceholder | translate) : ('grid.search' | translate)"
                                   (keyup)="searchKeyUp($event)">
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="grid.showIsCreditCheckbox">
                    <div class="checkbox-fade fade-in-primary d- mt-2 col-md-3">
                        <label>
                            <input #gridSearch type="checkbox" class="form-check-input"
                                   [(ngModel)]="searchQuery.isCredit"
                                   (ngModelChange)="sendRequest('resetPageOffset')">
                            <span class="cr cr-check-box"><i class="cr-icon fa fa-check txt-primary"></i></span>&nbsp;
                            <span class="text-inverse">{{ "grid.show_credit_invoices"|translate }}</span>
                        </label>
                    </div>
                </ng-container>
                <ng-container *ngIf="grid.inPopUp,else normalSearch">
                    <div *ngIf="grid.simpleSearch" class="col-md-6  d-flex align-items-center">
                        <label class="mb-0" for="gridSearch">{{ "grid.search"|translate }}&nbsp;</label>
                        <input #gridSearch type="text" class="form-control ms-2" [(ngModel)]="searchQuery.query"
                               [placeholder]="grid.searchPlaceholder ? (grid.searchPlaceholder | translate) : ('grid.search' | translate)"
                               (keyup)="searchKeyUp($event)">
                    </div>
                </ng-container>
                <ng-template #normalSearch>
                    <!--Normal search-->
                    <div *ngIf="grid.simpleSearch" class="col-md-3  d-flex align-items-center">
                        <label class="mb-0" for="gridSearch">{{ "grid.search"|translate }}&nbsp;</label>
                        <input #gridSearch type="text" class="form-control ms-2" [(ngModel)]="searchQuery.query"
                               [placeholder]="grid.searchPlaceholder ? (grid.searchPlaceholder | translate) : ('grid.search' | translate)"
                               (keyup)="searchKeyUp($event)">
                    </div>
                </ng-template>
            </div>

        </div>

        <div class="col-md-10 pt-0  box-sort-right" *ngIf="!grid.multipleRowSearch && grid.search ">
            <div class="row justify-content-end" *ngFor="let search of grid.search">
                <!--select search-->
                <!--we have many select search-->
                <div class="col-md-2 col-12 selectSearch" *ngFor="let searchItem of search.searchArrays"
                     [ngClass]="[search.order? 'order-'+searchItem.index:'']"
                     [ngStyle]="{'min-width.%': searchItem.width ? searchItem.width: null}">
                    <div class="input-group mb-0">
                        <label class="me-2 mb-0">{{ searchItem.label|translate }}</label>
                        <ng-select class="select-box"
                                   [items]="searchItem.value.value"
                                   [clearable]="true"
                                   [(ngModel)]="searchQuery.search[searchItem.name]"
                                   (clear)="searchItem.value.query = {term:''}; searchItem.value.getData()"
                                   (search)="searchItem.value.query = $event; searchItem.value.getData()"
                                   (change)="sendRequest('resetPageOffset')"
                                   bindValue="value" bindLabel="label"></ng-select>
                    </div>

                </div>
                <!--we have one select search-->
                <div class="col-md-3 col-12  pt-0   selectSearch" *ngIf="search.hasDropdownListFilter && search.value"
                     [ngClass]="[search.order? 'order-'+search.order[0].selectSearchOrder:'']">

                    <div class="input-group mb-0">
                        <label class="me-2 mb-0">{{ search.label|translate }}</label>
                        <ng-select class="select-box"
                                   [items]="search.value.value"
                                   [clearable]="true"
                                   [(ngModel)]="searchQuery.search[search.name]"
                                   id="selectSearch"
                                   (clear)="search.value.query = {term:''}; search.value.getData()"
                                   (search)="search.value.query = $event; search.value.getData()"
                                   (change)="sendRequest('resetPageOffset')"
                                   bindValue="value" bindLabel="label"></ng-select>
                    </div>

                </div>

                <!--action with button-->
                <div class="col-12 d-flex selectSearch action-box"
                     *ngIf="search.hasDropdownListFilter && search.order"
                     [ngClass]="[search.order? 'order-'+search.order[0].actionOrder:'' , grid.multipleRowSearch ? 'col-md-2':'col-md-3']">
                    <div class="input-group mb-0">
                        <label class="me-2 mb-0">{{ 'global.actions'|translate }}</label>
                        <ng-select #bulkActionSelect class="select-box"
                                   [items]="actions"
                                   [clearable]="true"
                                   [(ngModel)]="searchQuery.search[search.name]"
                                   (change)="selectAction($event)"
                                   bindValue="value" bindLabel="label">
                        </ng-select>

                        <div class="input-group-append" *ngIf="search.hasDropdownListFilter">
                            <button class="btn btn-primary btn-sm" (click)="bulkAction()"
                                    [ngStyle]="{'opacity': changeOrderStatusProcessing ? 0.7 : 1}">
              <span *ngIf="changeOrderStatusProcessing" class="spinner-border spinner-border-sm" role=" status"
                    aria-hidden="true"></span>
                                {{ (changeOrderStatusProcessing ? 'global.loading' : 'global.apply') | translate }}
                            </button>
                        </div>

                    </div>
                </div>

                <!--datepicker-->
                <div class="col-md-5 pt-0  d-flex align-items-center datepicker"
                     *ngIf="search.hasCalendar"
                     [ngClass]="[search.order? 'order-'+search.order[0].datepickerOrder:'']"
                     [ngStyle]="{'max-width.%': search.calendarCustomWidth ? search.calendarCustomWidth: null}">
                    <div class="row ">
                        <div class="col col d-flex align-items-center">
                            <div class="input-group mb-0" (clickOutside)="from.close()">
                                <label class="me-2 mb-0">{{ "grid.from" | translate }}</label>
                                <input class="form-control ms-2 "
                                       [placeholder]="calendarPlaceOrder"
                                       name="fromdate"
                                       [(ngModel)]="searchQuery.search['from']"
                                       ngbDatepicker
                                       #from="ngbDatepicker"
                                       (dateSelect)="sendRequest('resetPageOffset')"
                                       (change)="sendRequest('resetPageOffset')"
                                >
                                <div class="input-group-append">
                                    <button class="btn btn-nopadding btn-outline-secondary calendar feather icon-calendar"
                                            (click)="from.toggle()" type="button">

                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col col d-flex align-items-center">
                            <div class="input-group mb-0" (clickOutside)="to.close()">
                                <label class="me-2 mb-0">{{ "grid.to" | translate }}</label>
                                <input class="form-control ms-2 "
                                       [placeholder]="calendarPlaceOrder"
                                       name="todate"
                                       [(ngModel)]="searchQuery.search['to']"
                                       ngbDatepicker
                                       #to="ngbDatepicker"
                                       (dateSelect)="sendRequest('resetPageOffset')"
                                       (change)="sendRequest('resetPageOffset')"
                                >
                                <div class="input-group-append">
                                    <button class="btn btn-nopadding btn-outline-secondary calendar feather icon-calendar"
                                            (click)=" to.toggle()" type="button"
                                            (change)="sendRequest('resetPageOffset')">

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--status-->
                <div class="col-md-2 pt-0  col d-flex align-items-center" *ngIf="search.hasStatus"
                     [ngClass]="[search.order? 'order-'+search.order[0].statusOrder:'']">
                    <label class="me-2 mb-0">{{ 'global.status'| translate }}</label>
                    <ng-container *ngIf="search.isInvoiceStatus">
                        <ng-select class="w-100 custom-width-dealer-status"
                                   [items]="invoiceStatus"
                                   [clearable]="true"
                                   [(ngModel)]="searchQuery.search['invoiceStatus']"
                                   #statusDropdownList
                                   (clear)="search.value.query = {term:''}; search.value.getData()"
                                   (search)="search.value.query = $event; search.value.getData()"
                                   (change)="sendRequest('resetPageOffset')"
                                   bindValue="value" bindLabel="label"></ng-select>
                    </ng-container>
                    <ng-container *ngIf="!search.isInvoiceStatus">
                        <ng-select class="w-100 custom-width-dealer-status"
                                   [items]="status"
                                   [clearable]="true"
                                   [(ngModel)]="searchQuery.search['status']"
                                   #statusDropdownList
                                   (clear)="search.value.query = {term:''}; search.value.getData()"
                                   (search)="search.value.query = $event; search.value.getData()"
                                   (change)="sendRequest('resetPageOffset')"
                                   bindValue="value" bindLabel="label"></ng-select>
                    </ng-container>

                </div>


                <!--Normal search-->
                <div class="col-md-3 pt-0 d-flex align-items-center" *ngIf="search.hasNormalSearch"
                     [ngClass]="[search.order? 'order-'+search.order[0].normalSearchOrder:'' , search.hasDropdownListFilter && search.order ? 'offset-md-1':'']">
                    <label class="mb-0" for="gridSearch">{{ "grid.search"|translate }}&nbsp;</label>
                    <input #gridSearch type="text" class="form-control ms-2" id="gridSearch"
                           [(ngModel)]="searchQuery.query"
                           [placeholder]="grid.searchPlaceholder ? (grid.searchPlaceholder | translate) : ('grid.search' | translate)"
                           (keyup)="searchKeyUp($event)">
                </div>


            </div>
            <div class="row justify-content-end" *ngIf="!grid.doseNotHaveSearch">
                <!--Normal search-->
                <div class="col-md-2 pt-0  col-12 d-flex align-items-center">
                    <label class="mb-0" for="gridSearch3">{{ "grid.search"|translate }}&nbsp;</label>
                    <input #gridSearch type="text" class="form-control ms-2" id="gridSearch3"
                           [(ngModel)]="searchQuery.query"
                           [placeholder]="grid.searchPlaceholder ? (grid.searchPlaceholder | translate) : ('grid.search' | translate)"
                           (keyup)="searchKeyUp($event)">

                </div>

            </div>
        </div>
    </div>


    <div class="col-12" *ngIf="grid.multipleRowSearch">
        <div class="row mb-2 pt-0" *ngFor="let search of grid.search">

            <!--action with button-->
            <div class="col-md-2 col-12 d-flex selectSearch action-box"
                 *ngIf="search.hasDropdownListFilter "
                 [ngClass]="[search.order? 'order-'+search.order[0].actionOrder:'']">
                <div class="input-group mb-0">
                    <label class="me-2 mb-0">{{ 'global.actions'|translate }}</label>
                    <ng-select #bulkActionSelect class="select-box"
                               [items]="actions"
                               [clearable]="true"
                               [(ngModel)]="searchQuery.search[search.name]"
                               (change)="selectAction($event)"
                               bindValue="value" bindLabel="label">
                    </ng-select>

                    <div class="input-group-append" *ngIf="search.hasDropdownListFilter">
                        <button class="btn btn-primary btn-sm" (click)="bulkAction()"
                                [ngStyle]="{'opacity': changeOrderStatusProcessing ? 0.7 : 1}">
              <span *ngIf="changeOrderStatusProcessing" class="spinner-border spinner-border-sm" role=" status"
                    aria-hidden="true"></span>
                            {{ (changeOrderStatusProcessing ? 'global.loading' : 'global.apply') | translate }}
                        </button>
                    </div>

                </div>
            </div>
            <div class="col-md-2 col-12 d-flex selectSearch action-box"
                 *ngIf="search.hasBackofficeDropdownListFilter"
                 [ngClass]="[search.order? 'order-'+search.order[0].actionOrder:'']">
                <div class="input-group mb-0">
                    <label class="me-2 mb-0">{{ 'global.actions'|translate }}</label>
                    <ng-select class="select-box"
                               [items]="backofficeInvoiceActions"
                               [clearable]="true"
                               [(ngModel)]="searchQuery.search[search.name]"
                               (change)="selectAction($event)"
                               bindValue="value" bindLabel="label">
                    </ng-select>

                    <div class="input-group-append" *ngIf="search.hasBackofficeDropdownListFilter">
                        <button class="btn btn-primary btn-sm"
                                (click)="invoiceBulkAction()">{{ 'global.apply' | translate }}
                        </button>
                    </div>

                </div>
            </div>


            <div class="col-md-10" [ngClass]="[search.order? 'order-'+search.order[0].actionOrder:'']">
                <div class="row justify-content-end">
                    <!--we have many select search-->
                    <div class="col-md-2  d-flex selectSearch" *ngFor="let searchItem of search.searchArrays"
                         [ngClass]="[(search.order? 'order-'+searchItem.index:'')]"
                         [ngStyle]="{'min-width.%': searchItem.width ? searchItem.width: null}">
                        <br/>

                        <div class="input-group mb-0">
                            <label class="me-2 mb-0">{{ searchItem.label|translate }}</label>
                            <ng-select class="select-box"
                                       [items]="searchItem.value.value"
                                       [clearable]="true"
                                       [(ngModel)]="searchQuery.search[searchItem.name]"
                                       (clear)="searchItem.value.query = {term:''}; searchItem.value.getData()"
                                       (search)="searchItem.value.query = $event; searchItem.value.getData()"
                                       (change)="sendRequest('resetPageOffset')"
                                       bindValue="value" bindLabel="label"></ng-select>
                        </div>

                    </div>
                    <!--datepicker-->
                    <div class="col-md-5 col-12 d-flex align-items-center datepicker"
                         *ngIf="search.hasCalendar"
                         [ngClass]="[search.order? 'order-'+search.order[0].datepickerOrder:'']">
                        <div class="row ">
                            <div class="col  d-flex align-items-center">
                                <div class="input-group mb-0" (clickOutside)="from.close()">
                                    <label class="me-2 mb-0">{{ "grid.from" | translate }}</label>
                                    <input class="form-control ms-2 "
                                           [placeholder]="calendarPlaceOrder"
                                           name="fromdate"
                                           [(ngModel)]="searchQuery.search['from']"
                                           ngbDatepicker
                                           #from="ngbDatepicker"
                                           (dateSelect)="sendRequest('resetPageOffset')"
                                           (change)="sendRequest('resetPageOffset')"
                                    >
                                    <div class="input-group-append">
                                        <button class="btn btn-nopadding btn-outline-secondary calendar feather icon-calendar"
                                                (click)="from.toggle()" type="button">

                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col  d-flex align-items-center">
                                <div class="input-group mb-0" (clickOutside)="to.close()">
                                    <label class="me-2 mb-0">{{ "grid.to" | translate }}</label>
                                    <input class="form-control ms-2 "
                                           [placeholder]="calendarPlaceOrder"
                                           name="todate"
                                           [(ngModel)]="searchQuery.search['to']"
                                           ngbDatepicker
                                           #to="ngbDatepicker"
                                           (dateSelect)="sendRequest('resetPageOffset')"
                                           (change)="sendRequest('resetPageOffset')"
                                    >
                                    <div class="input-group-append">
                                        <button class="btn btn-nopadding btn-outline-secondary calendar feather icon-calendar"
                                                (click)=" to.toggle()" type="button"
                                                (change)="sendRequest('resetPageOffset')">

                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--status-->
                    <div class="col-md-2  d-flex align-items-center" *ngIf="search.hasStatus"
                         [ngClass]="[search.order? 'order-'+search.order[0].statusOrder:'']">
                        <label class="me-2 mb-0">{{ "global.status" | translate }}</label>
                        <ng-select class="w-100 custom-width-backoffcie-status"
                                   [items]="status"
                                   [clearable]="true"
                                   [(ngModel)]="searchQuery.search['status']"
                                   id="hasStatus"
                                   #statusDropdownList
                                   (clear)="search.value.query = {term:''}; search.value.getData()"
                                   (search)="search.value.query = $event; search.value.getData()"


                                   bindValue="value" bindLabel="label"></ng-select>
                    </div>
                    <div class="col-md-2  d-flex align-items-center" *ngIf="search.hasInvoiceStatus"
                         [ngClass]="[search.order? 'order-'+search.order[0].statusOrder:'']">
                        <label class="me-2 mb-0">{{ "global.status" | translate }}</label>
                        <ng-container *ngIf="search.hasInvoiceStatus">
                            <ng-select class="w-100 custom-width-backoffcie-status"
                                       [items]="backofficeInvoiceStatus"
                                       [clearable]="true"
                                       [(ngModel)]="searchQuery.search['invoiceStatus']"
                                       #statusDropdownList
                                       (clear)="search.value.query = {term:''}; search.value.getData()"
                                       (search)="search.value.query = $event; search.value.getData()"
                                       (change)="sendRequest('resetPageOffset')"
                                       bindValue="value" bindLabel="label"></ng-select>
                        </ng-container>
                    </div>
                </div>


            </div>

        </div>
    </div>


    <!--grid show-->
    <div class="col-12" #tableWrapper>
        <ngx-datatable
            #gridSystem
            class="data-table ngx-datatable"
            [rows]="pagination.data"
            [messages]="messages"
            [columns]="columns"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [externalPaging]="true"
            [count]="searchQuery.count"
            [offset]="searchQuery.offset"
            [limit]="searchQuery.limit"
            (page)='onPage($event)'
            [externalSorting]="true"
            [loadingIndicator]="loadingIndicator"
            (sort)="onSort($event)"
            [rowHeight]="'auto'"
            (activate)="selectRow($event)"
        >
            <ngx-datatable-footer>
                <ng-template
                        ngx-datatable-footer-template
                        let-rowCount="rowCount"
                        let-pageSize="pageSize"
                        let-selectedCount="selectedCount"
                        let-curPage="curPage"
                        let-offset="offset"
                        let-isVisible="isVisible">
                    <div class="c-absolute-class">
                        <ng-container *ngIf="searchQuery.count === 0; else showCount">0</ng-container>
                        <ng-template #showCount>
                            {{ (getCurrentPageTotal() - total) + 1 }}
                        </ng-template>
                        {{ "grid.to"|translate }} {{ (getCurrentPageTotal()) >= searchQuery.count ? searchQuery.count : (getCurrentPageTotal()) }}
                        - {{ searchQuery.count }} {{ "grid.items"|translate }}
                        <div class="text-start">
                        </div>
                    </div>
                    <datatable-pager
                            [pagerLeftArrowIcon]="'datatable-icon-left'"
                            [pagerRightArrowIcon]="'datatable-icon-right'"
                            [pagerPreviousIcon]="'datatable-icon-prev'"
                            [pagerNextIcon]="'datatable-icon-skip'"
                            [page]="curPage"
                            [size]="pageSize"
                            [count]="rowCount"
                            [hidden]="!((rowCount / pageSize) > 1)"
                            (change)="table.onFooterPage($event)"
                    >
                    </datatable-pager>
                </ng-template>
            </ngx-datatable-footer>
            <ng-template #actionsColumnHeader let-column="column">
                <div>
            <span
                    class="datatable-header-cell-label">{{ column.translate ? (column.name |translate) : column.name }}</span>
                </div>
            </ng-template>


            <!--  Boolean COLUMN  -->
            <ng-template #boolColumnVal let-row="row" let-column="column" let-value="value" let-i="index">
        <span class="text-center">
          <input type="checkbox" value="" (change)="addSelected($event,row)"
                 [checked]="checkedAll || selectedIds.includes(row.id)">
        </span>

            </ng-template>

            <ng-template #boolColumnHeader let-column="column" let-sortDir="sortDir" let-sortFn="sortFn">
        <span class="datatable-header-cell-label text-center">
          <input type="checkbox" value="" (change)="selectAll($event)" [checked]="checkedAll">
        </span>
            </ng-template>

            <ng-template #numberColumnVal let-row="row" let-column="column" let-value="value" let-i="index">
                <div class="form-group row">
                    <div class="col-10  text-center">
                        <input type="number" [name]="'position'+row.id" [disabled]="disabledPosition" [value]="value"
                               min="-1"
                               (blur)="column.change($event,row)" class="form-control">
                    </div>
                </div>
            </ng-template>

            <ng-template #numberColumnHeader let-column="column" let-sortDir="sortDir" let-sortFn="sortFn">
                <p class=" datatable-header-cell-label" (click)="sortFn()"
                   [title]="column.translate?(column.name |translate):column.name">{{ column.translate ? (column.name |translate) : column.name }}
                    <span *ngIf="column.sortable">
              <i class="sortArrow sortArrowDown fa fa-long-arrow-down pt-1"
                 [ngStyle]="{'opacity': (sortDir!=='desc') ? 0.3 : 0.8}"></i>
            </span>
                    <span *ngIf="column.sortable">
              <i class="sortArrow fa fa-long-arrow-up pt-1" [ngStyle]="{'opacity': (sortDir!=='asc') ? 0.3 : 0.8}"></i>
            </span>
                </p>
            </ng-template>


            <!--  TEXT COLUMN  -->
            <ng-template #textColumnVal let-row="row" let-column="column" let-value="value" let-i="index">
                <div class="data-table-inner-value" [style.padding]="column.paddingVal"
                     [attr.data-testid]="column.testId"
                     [ngClass]="{'text-truncate': !column.noTruncate}">
                    <span *ngIf="column.isHtml && !column.valueTemplate"
                          [innerHTML]="column.valueFormatter ? column.valueFormatter(value) : (column.translateValue ? (value|translate) : value)"></span>
                    <div *ngIf="!column.isHtml && !column.valueTemplate && column.hasStatus" style="display: flex">
            <span
                    [class]="column.valueClassFormatter?column.valueClassFormatter(value):''">{{ column.valueFormatter ? column.valueFormatter(value) : (column.translateValue ? (value|translate) : value) }} </span><span
                            class="status-days">{{ column.valueStatusFormatter ? column.valueStatusFormatter(row) : '' }}</span>
                    </div>
                    <span *ngIf="!column.isHtml && !column.valueTemplate && !column.hasStatus"
                          [class]="column.valueClassFormatter?column.valueClassFormatter(value):''">{{ column.valueFormatter ? column.valueFormatter(value) : (column.translateValue ? (value|translate) : value) }}</span>
                    <ng-template *ngIf="column.valueTemplate" [ngTemplateOutlet]="column.valueTemplate"
                                 [ngTemplateOutletContext]="{ value: value, row: row, column: column }">
                    </ng-template>
                </div>
            </ng-template>
            <ng-template #textColumnHeader let-column="column" let-sortDir="sortDir" let-sortFn="sortFn">
                <div *ngIf="!column.possibleItems" [title]="column.translate?(column.name |translate):column.name"
                     [ngStyle]="{'position':'relative'}" (clickOutside)="closeFilterTab(column)">
                    <p class=" datatable-header-cell-label"
                       [title]="column.translate?(column.name |translate):column.name">{{ column.translate ? (column.name |translate) : column.name }}
                        <span *ngIf="column.sortable" (click)="sortFn()">
              <i class="sortArrow sortArrowDown fa fa-long-arrow-down pt-1"
                 [ngStyle]="{'opacity': (sortDir!=='desc') ? 0.3 : 0.8}"></i>
            </span>
                        <span *ngIf="column.sortable" (click)="sortFn()">
              <i class="sortArrow fa fa-long-arrow-up pt-1" [ngStyle]="{'opacity': (sortDir!=='asc') ? 0.3 : 0.8}"></i>
            </span>
                        <span *ngIf="column.filterable" class="filterBtn" (click)="openFilterTab(column)"><i
                                class="fa fa-filter pt-1 me-1" aria-hidden="true"
                                [ngStyle]="{'opacity': column.isFilterSelected ? 0.8 : 0.3 , 'float':'right'}"></i></span>
                    </p>
                    <div class="datatable-header-filter-tab" *ngIf="column.isFilterTabOpen">
                        <ng-select class="select-box"
                                   [items]="column.filterItems"
                                   [clearable]="true"
                                   [multiple]="column.filterMultiSelect"
                                   [closeOnSelect]="!column.filterMultiSelect"
                                   [(ngModel)]="column.filterSelectedItems"
                                   (change)="filterChange(column)"
                                   [isOpen]="true"
                                   bindValue="value" bindLabel="label"></ng-select>
                    </div>
                </div>
            </ng-template>


            <ng-template #actionColumnValue let-column="column" let-row="row">
                <div class="text-start">
                    <div class="data-table-inner-value " [ngClass]="{'buttonViewChange btn-group':buttonViewChange}"
                         [style.padding]="column.paddingVal">
                        <ng-container *ngFor="let actionItem of column.actionItems">
              <span *ngIf="(!actionItem.hasOwnProperty('status')||actionItem.status) && (!actionItem.showCallback || (actionItem.showCallback && actionItem.showCallback(row)))"
                    class="action-button">
                       <a href="javascript:"
                          [class]="actionItem.btnClass"
                          [ngClass]="{'disabled': isActionDisabled(actionItem, row)}"
                          [attr.aria-disabled]="isActionDisabled(actionItem, row) ? true : null"
                          (click)="onActionClick($event, actionItem, row)"
                          placement="top" ngbTooltip="{{(actionItem.tooltip ? actionItem.tooltip : '') | translate}}">
                <i *ngIf="actionItem.icon.length>0"
                   [class]="actionItem.icon"></i>
                <span *ngIf="actionItem.name">{{ actionItem.name|translate }}</span>
              </a>

              </span>
                        </ng-container>
                    </div>
                </div>

            </ng-template>

            <ngx-datatable-row-detail *ngIf="grid.rowDetailTemplate" [rowHeight]="'auto'">
                <ng-template let-row="row" let-value="value" let-column="column" ngx-datatable-row-detail-template>
                    <div>
                        <div class="expand-box box-arrow"
                             (click)="toggleExpandRow(row)">
                            <a href="javascript:">
                                <i [tooltip]="'panel.grids.actions.expand row' | translate" tooltipPlacement="top"
                                   class="fa fa-chevron-up"></i>
                            </a>
                        </div>
                        <div class="expand-box box-template">
                            <ng-template
                                    *ngIf="(grid.rowDetailShowCallback && grid.rowDetailShowCallback(row,clientWidth)|| !grid.rowDetailShowCallback)"
                                    [ngTemplateOutlet]="grid.rowDetailTemplate"
                                    [ngTemplateOutletContext]="{ value: value, row: row, column: column }">
                            </ng-template>
                        </div>

                    </div>
                </ng-template>
            </ngx-datatable-row-detail>
        </ngx-datatable>
    </div>
</div>

